import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface ArEvidenceEvent {
  ts: string;
  outcome: string | null;
  notes: string | null;
  gmailMessageId: string | null;
  qbReconciled: boolean;
  qbReconciledAt: string | null;
  qbPaymentId: string | null;
  stripeChargeId: string | null;
  stripePaymentIntentId: string | null;
  stripePayoutId: string | null;
  invoiceStatus: string | null;
  balance: number | null;
  docLinked: boolean;
  docLinkedAt: string | null;
  dmsDocumentId: string | null;
  retryCount: number | null;
}

export interface ArEvidenceResponse {
  invoiceNumber: string;
  events: ArEvidenceEvent[];
}

/**
 * AR engine reconciliation history for an invoice — every per-cycle attempt the
 * bookkeeper ran (outcome, notes, the Gmail message it processed, payment/bank/
 * Stripe reconciliation), oldest-first. Read-only.
 * Routes through web_api_server: GET /v4/invoices/by-number/:n/ar-evidence.
 */
export function useInvoiceArEvidence(invoiceNumber: string, enabled: boolean) {
  return useQuery<ArEvidenceResponse>({
    queryKey: ['aging', 'invoice-ar-evidence', invoiceNumber],
    queryFn: () =>
      api.get<ArEvidenceResponse>(
        `/v4/invoices/by-number/${encodeURIComponent(invoiceNumber)}/ar-evidence`,
      ),
    enabled: enabled && !!invoiceNumber,
    staleTime: 5 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
  });
}
